module.exports = __webpack_public_path__ + "static/media/aTeamerResidence.6870db2a.svg";